import classNames from 'classnames';
import React from 'react';
import { Box } from '@wix/design-system';
import { Collapse, ToggleCollapsibleButton, useCollapse, } from '../../../Collapse';
import s from './FeatureGroup.scss';
export const FeatureGroup = ({ dataHook, className, header, children, collapsible, isOpen: isOpenDefault = true, groupHeaderClassName, labels, onToggle, }) => {
    const { isOpen, toggleCollapse } = useCollapse({
        isOpen: isOpenDefault,
        collapsible,
    });
    const [isHovering, setIsHovering] = React.useState(false);
    const handleClick = () => {
        onToggle?.(isOpen ? 'close' : 'open');
        toggleCollapse();
    };
    return (React.createElement(Box, { className: classNames(s.featureGroup, className), direction: "vertical", dataHook: dataHook },
        React.createElement("div", { onClick: handleClick, onMouseEnter: () => setIsHovering(true), onMouseLeave: () => setIsHovering(false) },
            React.createElement(Box, { className: classNames(s.featureGroupHeader, groupHeaderClassName), height: "60px", gap: "9px", verticalAlign: "middle", justifyItems: "space-between", cursor: collapsible ? 'pointer' : 'default' },
                React.createElement(Box, { flex: 1 }, header),
                collapsible && (React.createElement(ToggleCollapsibleButton, { isOpen: isOpen, labels: labels, visible: isHovering, skin: "dark", size: "tiny", classNames: {
                        icon: classNames(s.dark, s.circle),
                    } })))),
        React.createElement(Collapse, { className: s.collapsible, isOpened: isOpen || !collapsible },
            React.createElement(Box, { className: s.featureGroupSubGrid }, children))));
};
//# sourceMappingURL=FeatureGroup.js.map